export default __webpack_public_path__ + "static/media/gia_thue_xe_4cho_tai_tphcm.9dcd3930.svg";